var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"type":4},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{class:['key-dialog', 'key-dialog-' + _vm.dialogClass]},[_c('div',{class:[
        'key-sum',
        'key-sum-' + (_vm.lotteryInfo.category ? 'gold' : 'diamond')
      ]},[_vm._v(" X"+_vm._s(_vm.lotteryInfo.num)+" ")]),_c('img',{staticClass:"btn-open",attrs:{"src":require("./img/key/btn-open.png")},on:{"click":_vm.open}})])])}
var staticRenderFns = []

export { render, staticRenderFns }